"use client";
import { useSession } from "@/lib/auth-client";
import { KeyIcon, PlusIcon, SearchIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { Avatar } from "../ui/avatar";
import { Button } from "../ui/button";
export default function NavBar() {
  const { data: session } = useSession();
  const t = useTranslations("NavBar");
  const isLoggedIn = session?.user;

  // Check if the user is logged in and has a role
  const isRepondant =
    session !== undefined && session?.user?.role === "REPONDANT";
  const isPlanificateur =
    session !== undefined && session?.user?.role === "PLANIFICATION";
  const isAdmin = session !== undefined && session?.user?.role === "ADMIN";
  const isUnapproved =
    session !== undefined && session?.user?.role === "UNAPPROVED";

  return (
    <div className="navbar bg-white border-b shadow-sm">
      <div className="flex-1 flex items-center gap-4">
        <Link href="/">
          <Image src="/logo_alumni.jpg" alt="logo" width={180} height={100} />
        </Link>
        {isLoggedIn && (
          <div className="flex gap-2">
            {(isRepondant || isPlanificateur || isAdmin) && (
              <Link href="/suivis">
                <Button
                  variant="ghost"
                  className="text-neutral-800 dark:text-neutral-900"
                >
                  {t("caller_lists")}
                </Button>
              </Link>
            )}
            {(isPlanificateur || isAdmin) && (
              <Link href="/planification">
                <Button
                  variant="ghost"
                  className="text-neutral-800 dark:text-neutral-900"
                >
                  {t("planification")}
                </Button>
              </Link>
            )}
            {isAdmin && (
              <Link href="/statistics">
                <Button
                  variant="ghost"
                  className="text-neutral-800 dark:text-neutral-900"
                >
                  {t("statistics")}
                </Button>
              </Link>
            )}
          </div>
        )}
      </div>
      {isLoggedIn && (
        <div className="flex-none gap-2 flex items-center">
          {!isUnapproved && (
            <div>
              <Link href="/suivi/nouveau">
                <Button
                  variant="outline"
                  size="icon"
                  className="text-neutral-800 dark:text-neutral-900"
                >
                  <PlusIcon className="h-5 w-5" />
                </Button>
              </Link>
              <Link href="/search">
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-neutral-800 dark:text-neutral-900"
                >
                  <SearchIcon />
                </Button>
              </Link>
              {isAdmin && (
                <Link href="/admin">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="text-neutral-800 dark:text-neutral-900"
                  >
                    <KeyIcon />
                  </Button>
                </Link>
              )}
            </div>
          )}
          <div className="dropdown dropdown-end inline-flex items-center gap-2">
            {session?.user?.name && (
              <span className="text-sm text-neutral-600">
                {session.user.name}
              </span>
            )}
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost btn-circle avatar"
            >
              <div className="text-neutral-800 dark:text-neutral-900">
                <Avatar>
                  <svg
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </Avatar>
              </div>
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-white rounded-box z-[1] mt-3 p-2 shadow-lg border"
            >
              <li>
                <Link
                  href="/auth/user-settings"
                  className="text-neutral-800 dark:text-neutral-900 hover:bg-neutral-100"
                >
                  {t("settings")}
                </Link>
              </li>
              <li>
                <Link
                  href="/auth/sign-out"
                  className="text-neutral-800 dark:text-neutral-900 hover:bg-neutral-100"
                >
                  {t("signOut")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
